module.exports = __webpack_public_path__ + "img/garmin-watch2.302f11a3.jpg";